<ng-container [formGroup]="metadataFormGroup">
  <app-shared-business-form
    [formGroup]="sharedBusinessFormGroup"
    [showStaffFields]="true"
    [showActivityFields]="false"
  />

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations Assurance LAA
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Masse salariale accident professionnel hommes (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="professionalMenTotalSalary"
      />
    </div>
    <div class="col">
      <label i18n>Masse salariale accident professionnel femmes (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="professionalWomenTotalSalary"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n
        >Masse salariale accident non-professionnel hommes (CHF)</label
      >
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="nonProfessionalMenTotalSalary"
      />
    </div>
    <div class="col">
      <label i18n
        >Masse salariale accident non-professionnel femmes (CHF)</label
      >
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="nonProfessionalWomenTotalSalary"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Nombre de femmes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="womenCount"
      />
    </div>
    <div class="col">
      <label i18n>Nombre d'hommes</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="menCount"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Contrat collectif</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasCollectiveContract"
          id="hasCollectiveContractFalse"
          [value]="false"
          formControlName="hasCollectiveContract"
        />
        <label class="form-check-label" for="hasCollectiveContractFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasCollectiveContract"
          id="hasCollectiveContractTrue"
          [value]="true"
          formControlName="hasCollectiveContract"
        />
        <label class="form-check-label" for="hasCollectiveContractTrue">
          Oui
        </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasCollectiveContract === 'true' ||
        metadataFormGroup.value.hasCollectiveContract === true
      "
    >
      <label i18n>Contrat collectif</label>
      <input
        type="text"
        class="form-control"
        formControlName="collectiveContract"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Obligatoirement SUVA</label>
      <div class="form-check">
        <input
          type="radio"
          name="suvaOnly"
          id="suvaOnlyFalse"
          [value]="false"
          formControlName="suvaOnly"
        />
        <label class="form-check-label" for="suvaOnlyFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="suvaOnly"
          id="suvaOnlyTrue"
          [value]="true"
          formControlName="suvaOnly"
        />
        <label class="form-check-label" for="suvaOnlyTrue"> Oui </label>
      </div>
    </div>
    <div class="col">
      <label i18n>LAA</label>
      <div class="form-check">
        <input
          type="radio"
          name="baseInsurance"
          id="baseInsuranceFalse"
          [value]="false"
          formControlName="baseInsurance"
        />
        <label class="form-check-label" for="baseInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="baseInsurance"
          id="baseInsuranceTrue"
          [value]="true"
          formControlName="baseInsurance"
        />
        <label class="form-check-label" for="baseInsuranceTrue"> Oui </label>
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>LAAC</label>
      <div class="form-check">
        <input
          type="radio"
          name="complementaryInsurance"
          id="complementaryInsuranceFalse"
          [value]="false"
          formControlName="complementaryInsurance"
        />
        <label class="form-check-label" for="complementaryInsuranceFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="complementaryInsurance"
          id="complementaryInsuranceTrue"
          [value]="true"
          formControlName="complementaryInsurance"
        />
        <label class="form-check-label" for="complementaryInsuranceTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Cercle des personnes assurées
  </div>
  <div class="row mb-4">
    <div class="col">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [value]="true"
          id="allCollaboratorsCovered"
          formControlName="allCollaboratorsCovered"
        />
        <label class="form-check-label" for="allCollaboratorsCovered">
          Tous les collaborateurs sont assurés
        </label>
      </div>
    </div>
  </div>
  @if (
    metadataFormGroup?.controls?.['allCollaboratorsCovered']?.value !== true
  ) {
    <div formArrayName="insuredPersons">
      <div
        *ngFor="let personControl of insuredPersons.controls; let i = index"
        [formGroupName]="i"
        class="insured-person-row mb-3 p-3 border rounded"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 i18n>Personne {{ i + 1 }}</h6>
          <button
            type="button"
            class="lty-btn lty-btn-danger btn-sm"
            (click)="removeInsuredPerson(i)"
            i18n
          >
            Supprimer
          </button>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label i18n>Sélectionner un collaborateur (optionnel)</label>
            <select
              class="form-control"
              (change)="onCollaboratorSelected(i, $any($event.target).value)"
            >
              <option [value]="null" i18n>Sélectionner</option>
              <option
                *ngFor="let collaborator of collaborators"
                [value]="collaborator.id"
                [selected]="
                  personControl.value.collaboratorId === collaborator.id
                "
              >
                {{ collaborator.firstName }} {{ collaborator.lastName }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label i18n>Nom complet</label>
            <input
              type="text"
              class="form-control"
              formControlName="fullName"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="lty-btn lty-btn-white add-person-btn me-auto ms-auto w-100"
      (click)="addInsuredPerson()"
    >
      <span class="plus_sign me-2">+</span>
      <span i18n>Ajouter une personne assurée</span>
    </button>
  }

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations du contrat
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option [value]="null" i18n>Sélectionner</option>
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Prestations assurées
  </div>

  <ng-container formGroupName="coverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Prestations assurées durant les 2 premiers jours</label>
        <div class="form-check">
          <input
            type="radio"
            id="insuredBenefitsFirstTwoDaysFalse"
            [value]="false"
            formControlName="insuredBenefitsFirstTwoDays"
          />
          <label
            class="form-check-label"
            for="insuredBenefitsFirstTwoDaysFalse"
          >
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="insuredBenefitsFirstTwoDaysTrue"
            [value]="true"
            formControlName="insuredBenefitsFirstTwoDays"
          />
          <label class="form-check-label" for="insuredBenefitsFirstTwoDaysTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Prestations assurées dès le 3ème jour</label>
        <div class="form-check">
          <input
            type="radio"
            id="insuredBenefitsThirdDayFalse"
            [value]="false"
            formControlName="insuredBenefitsThirdDay"
          />
          <label class="form-check-label" for="insuredBenefitsThirdDayFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="insuredBenefitsThirdDayTrue"
            [value]="true"
            formControlName="insuredBenefitsThirdDay"
          />
          <label class="form-check-label" for="insuredBenefitsThirdDayTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-1 my-3">
      <div class="col">
        <label i18n>Délai d'attente en jours</label>
        <select class="form-control" formControlName="waitingDelay">
          <option [value]="null" i18n>Sélectionner</option>
          <option *ngFor="let value of waitingDaysValues" [value]="value">
            {{ getBusinessWaitingDaysLabel(value) }}
          </option>
        </select>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Salaire maximum assuré</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="maximumInsuredSalary"
        />
      </div>
      <div class="col">
        <label i18n>Rente d'invalidité</label>
        <div class="form-check">
          <input
            type="radio"
            id="invalidityPensionFalse"
            [value]="false"
            formControlName="invalidityPension"
          />
          <label class="form-check-label" for="invalidityPensionFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="invalidityPensionTrue"
            [value]="true"
            formControlName="invalidityPension"
          />
          <label class="form-check-label" for="invalidityPensionTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Rente de survivants : durée</label>
        <input
          type="text"
          class="form-control"
          formControlName="survivalPensionDuration"
        />
      </div>
      <div class="col">
        <label i18n>Couverture des salaires excédentaires</label>
        <div class="form-check">
          <input
            type="radio"
            id="excessSalariesFalse"
            [value]="false"
            formControlName="excessSalaries"
          />
          <label class="form-check-label" for="excessSalariesFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="excessSalariesTrue"
            [value]="true"
            formControlName="excessSalaries"
          />
          <label class="form-check-label" for="excessSalariesTrue"> Oui </label>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="col">
        <label i18n>Prestations assurées</label>
        <mat-form-field class="lty-input">
          <mat-select formControlName="coverages" multiple>
            <mat-option
              *ngFor="let coverage of coverageValues"
              [value]="coverage"
            >
              {{ getBusinessAccidentInsuranceCoverageLabel(coverage) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Délai d'attente en jours</label>
        <select class="form-control" formControlName="coveragesWaitingDelay">
          <option [value]="null" i18n>Sélectionner</option>
          <option *ngFor="let value of waitingDaysValues" [value]="value">
            {{ getBusinessWaitingDaysLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label i18n>Frais de traitement en chambre privée</label>
        <div class="form-check">
          <input
            type="radio"
            id="privateTreatmentFeesFalse"
            [value]="false"
            formControlName="privateTreatmentFees"
          />
          <label class="form-check-label" for="privateTreatmentFeesFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="privateTreatmentFeesTrue"
            [value]="true"
            formControlName="privateTreatmentFees"
          />
          <label class="form-check-label" for="privateTreatmentFeesTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Capital invalidité (350%) sur salaire LAA</label>
        <div class="form-check">
          <input
            type="radio"
            id="capitalInvalidityLaaSalaryFalse"
            [value]="false"
            formControlName="capitalInvalidityLaaSalary"
          />
          <label class="form-check-label" for="capitalInvalidityLaaSalaryFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="capitalInvalidityLaaSalaryTrue"
            [value]="true"
            formControlName="capitalInvalidityLaaSalary"
          />
          <label class="form-check-label" for="capitalInvalidityLaaSalaryTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Capital invalidité (350%) sur salaire excédentaire</label>
        <div class="form-check">
          <input
            type="radio"
            id="capitalInvalidityExcessSalaryFalse"
            [value]="false"
            formControlName="capitalInvalidityExcessSalary"
          />
          <label
            class="form-check-label"
            for="capitalInvalidityExcessSalaryFalse"
          >
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="capitalInvalidityExcessSalaryTrue"
            [value]="true"
            formControlName="capitalInvalidityExcessSalary"
          />
          <label
            class="form-check-label"
            for="capitalInvalidityExcessSalaryTrue"
          >
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Capital décès sur salaire LAA</label>
        <div class="form-check">
          <input
            type="radio"
            id="deathBenefitLaaSalaryFalse"
            [value]="false"
            formControlName="deathBenefitLaaSalary"
          />
          <label class="form-check-label" for="deathBenefitLaaSalaryFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="deathBenefitLaaSalaryTrue"
            [value]="true"
            formControlName="deathBenefitLaaSalary"
          />
          <label class="form-check-label" for="deathBenefitLaaSalaryTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Capital décès sur salaire excédentaire</label>
        <div class="form-check">
          <input
            type="radio"
            id="deathBenefitExcessSalaryFalse"
            [value]="false"
            formControlName="deathBenefitExcessSalary"
          />
          <label class="form-check-label" for="deathBenefitExcessSalaryFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="deathBenefitExcessSalaryTrue"
            [value]="true"
            formControlName="deathBenefitExcessSalary"
          />
          <label class="form-check-label" for="deathBenefitExcessSalaryTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Taux AP</label>
        <div class="form-check">
          <input
            type="radio"
            id="apRateFalse"
            [value]="false"
            formControlName="apRate"
          />
          <label class="form-check-label" for="apRateFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="apRateTrue"
            [value]="true"
            formControlName="apRate"
          />
          <label class="form-check-label" for="apRateTrue"> Oui </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Taux AANP</label>
        <div class="form-check">
          <input
            type="radio"
            id="aanpRateFalse"
            [value]="false"
            formControlName="aanpRate"
          />
          <label class="form-check-label" for="aanpRateFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="aanpRateTrue"
            [value]="true"
            formControlName="aanpRate"
          />
          <label class="form-check-label" for="aanpRateTrue"> Oui </label>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Prestations complémentaires
  </div>

  <ng-container formGroupName="additionalCoverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Reprise des cas de rechute</label>
        <div class="form-check">
          <input
            type="radio"
            id="relapseCasesFalse"
            [value]="false"
            formControlName="relapseCases"
          />
          <label class="form-check-label" for="relapseCasesFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="relapseCasesTrue"
            [value]="true"
            formControlName="relapseCases"
          />
          <label class="form-check-label" for="relapseCasesTrue"> Oui </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Garantie du taux de prime durant le contrat</label>
        <div class="form-check">
          <input
            type="radio"
            id="guaranteedPremiumRateFalse"
            [value]="false"
            formControlName="guaranteedPremiumRate"
          />
          <label class="form-check-label" for="guaranteedPremiumRateFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="guaranteedPremiumRateTrue"
            [value]="true"
            formControlName="guaranteedPremiumRate"
          />
          <label class="form-check-label" for="guaranteedPremiumRateTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture de la faute grave</label>
        <div class="form-check">
          <input
            type="radio"
            id="grossNegligenceFalse"
            [value]="false"
            formControlName="grossNegligence"
          />
          <label class="form-check-label" for="grossNegligenceFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="grossNegligenceTrue"
            [value]="true"
            formControlName="grossNegligence"
          />
          <label class="form-check-label" for="grossNegligenceTrue">
            Oui
          </label>
        </div>
      </div>
      <div class="col">
        <label i18n>Renonciation à la résiliation sur sinistre</label>
        <div class="form-check">
          <input
            type="radio"
            id="claimTerminationWaiverFalse"
            [value]="false"
            formControlName="claimTerminationWaiver"
          />
          <label class="form-check-label" for="claimTerminationWaiverFalse">
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="claimTerminationWaiverTrue"
            [value]="true"
            formControlName="claimTerminationWaiver"
          />
          <label class="form-check-label" for="claimTerminationWaiverTrue">
            Oui
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Participation à l'excédent de primes</label>
        <div class="form-check">
          <input
            type="radio"
            id="premiumSurplusParticipationFalse"
            [value]="false"
            formControlName="premiumSurplusParticipation"
          />
          <label
            class="form-check-label"
            for="premiumSurplusParticipationFalse"
          >
            Non
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="premiumSurplusParticipationTrue"
            [value]="true"
            formControlName="premiumSurplusParticipation"
          />
          <label class="form-check-label" for="premiumSurplusParticipationTrue">
            Oui
          </label>
        </div>
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('additionalCoverages')?.value
            ?.premiumSurplusParticipation === 'true' ||
          metadataFormGroup.get('additionalCoverages')?.value
            ?.premiumSurplusParticipation === true
        "
      >
        <label i18n>Si oui, période de calcul de l'excédent de primes</label>
        <input
          type="text"
          class="form-control"
          formControlName="premiumSurplusComputingPeriod"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assurance actuelle
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Possède une assurance</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceFalse"
          [value]="false"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceTrue"
          [value]="true"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasInsurance === 'true' ||
        metadataFormGroup.value.hasInsurance === true
      "
    >
      <label i18n>Assureur actuel</label>
      <input
        type="text"
        class="form-control"
        formControlName="currentInsurer"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n
        >A subi des sinistres ces 5 dernières années (alternatif)</label
      >
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
